import React from "react";
import Modal from "react-bootstrap/cjs/Modal";
import {CircularProgressbar,buildStyles} from "react-circular-progressbar";

const AlertModal: React.FC<{
  show: boolean;
  handleClose: any;
  type: string;
  progress?: number|undefined;
  message: string;
}> = ({ show, handleClose, type, message ,progress}) => {
  return (
    <Modal
      className="alert-modal"
      show={show}
      // onHide={handleClose}
      size="lg"
      style={{ borderRadius: "10px" }}
    >
      {/* <Modal.Header closeButton></Modal.Header> */}
      <Modal.Body className="Loading modal_height">
        {type == "Loading" ? (
          <div>
            <img src="/icons/loading.svg" className="loading_image" />

             <div style={{ textAlign: "center" }}>
              <p className="loading_typography">Loading</p>
            </div>
            <div className="loading_bar"></div>
          </div>
        ) : type == "Success" ? (
          <div>
            <img src="/icons/success.svg" className="loading_image" />
            <div
              style={{
                textAlign: "center",
              }}
            >
              <p
                className="loading_typography popup_typography

              "
              >
                {message}
              </p>
            </div>
            {/* <p className="loading_typography">SUCCESS</p> */}
            {/* <div className="success_bar"></div> */}

            {/* <p className="message_typography">{message}</p> */}
          </div>
        ) : type == "Error" ? (
          <div>
            {/* <div className="Loading "> */}
            <img src="/icons/error.svg" className="loading_image" />
            <div style={{ textAlign: "center" }}>
              <p className="loading_typography">{message}</p>
            </div>
            {/* <p className="loading_typography">ERROR</p> */}
            {/* <div className="error_bar"></div> */}
          </div>
        ) : type == "Progress" ? (
            <div>

              <div style={{margin:'30px',display:'flex',justifyContent:'center',alignItems:'center'}}>
                <CircularProgressbar
                    styles={buildStyles({
                      pathColor:'#24b2ff',
                      textColor: '#f88',
                      trailColor: '#d6d6d6',
                      backgroundColor: '#3e98c7',
                    })} value={progress===undefined?0:progress} />
                <div style={{position:'absolute'}}>
                  <img src="/icons/loading.svg" />
                  <p className='loading_typography'>{progress===undefined?0:progress}%</p>
                </div>

              </div>
              <div style={{ textAlign: "center",paddingBottom:'30px' }}>
                <p className="loading_typography" style={{fontSize:'13px'}}>{message}</p>
              </div>
            </div>
        ) : type == "wait" ? (
          <div>
            {/* <div className="Loading "> */}
            <img src="/icons/error.svg" className="loading_image" />
            <div style={{ textAlign: "center" }}>
              <p className="loading_typography">{message}</p>
            </div>
            {/* <div className="bubble">
              <p>{message}</p>
            </div> */}
            {/* <p className="loading_typography">ERROR</p> */}
            {/* <div className="error_bar"></div> */}
          </div>
        ) : type == "version" ? (
          <div>
            {/* <div className="Loading "> */}
            <img src="/icons/error.svg" className="loading_image" />
            <div style={{ textAlign: "center" ,marginLeft: "8%",marginTop: "2%"}}>
              <p className="loading_typography">{message}</p>
            </div>
            {/* <div className="bubble">
              <p>{message}</p>
            </div> */}
            {/* <p className="loading_typography">ERROR</p> */}
            {/* <div className="error_bar"></div> */}
          </div>
        ):(
          ""
        )}
        {type == "Loading" || type =="Progress" ? (
          <></>
        ) : (

          <button
          // style={{marginTop:"2%"}}
            onClick={handleClose}
            data-auto="inviteButton"
            className="spectrum-Button spectrum-Button--cta inviteButton-I4RMS ok_button"
          >
            <span>OK</span>
          </button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AlertModal;
